import { Grid } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState } from "react"
import { Formik } from "formik"
import { validationSchemaAdminUser } from "helpers/validationSchema"
import { formatDate } from "helpers/functions"
import AdminUserForm from "./adminUserForm/index"
import { useDispatch } from "react-redux"
import { uploadAdminUserAction } from "redux/superAdmin/actions"
import { useHistory } from "react-router-dom"

const isSpecial = {
  true: "true",
  false: "false"
}

const initialValues = {
  userType: "",
  role: "",
  fullName: "",
  restaurant: "",
  email: "",
  contactNumber: "",
  address: "",
  hireDate: "",
  reportingManager: "",
  specialUser: isSpecial.false.toString()
}

const AddAdminLineUser = () => {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [initialFormValue] = useState(initialValues)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
  }, [])

  function handleSubmit(values) {
    const payload = {
      full_name: values?.fullName,
      email: values?.email,
      phone_number: values?.contactNumber,
      role: values?.role,
      user_type: values?.userType,
      restaurant: values?.restaurant,
      address: values?.address,
      hire_date: formatDate(new Date(values?.hireDate)),
      reporting_manager: values?.reportingManager,
      is_special_user: values?.specialUser
    }
    dispatch(uploadAdminUserAction(payload))
    history.replace("/super-admin/dashboard/admin-user-list")
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header title="Add Admin User" breadCrumbs={breadCrumbs}></Header>
        </Grid>
      </Grid>
      <Formik
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={validationSchemaAdminUser}
        initialValues={initialFormValue}>
        {(formik) => <AdminUserForm formik={formik}></AdminUserForm>}
      </Formik>
    </>
  )
}

export default AddAdminLineUser
